import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleLeasingContact from '../useSingleLeasingContact';
import { getLeasingContactViewSections } from '../leasingContactViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleLeasingContact = () => {
  const { t } = useTranslation();
  const { singleItem, loading } = useSingleLeasingContact();

  const sections = useMemo(
    () => getLeasingContactViewSections(t, singleItem),
    [t, singleItem],
  );

  const pageTitle =
    [singleItem?.name, singleItem?.surname].filter(Boolean).join(' ') ||
    t('ELENCO CONTATTI COMMERCIALI');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/leasing/leasing_contacts/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/leasing/leasing_contacts'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleLeasingContact;
